import * as React from "react";

interface Auth {
  email: string;
  accessToken: string;
}

const AuthContext = React.createContext<{
  setAuth: (auth: Auth) => void;
  fetch?: typeof fetch;
  email?: string;
}>({
  setAuth: () => {
    void 0;
  },
});

export { Auth, AuthContext };
